import { render } from "./NewsInner.vue?vue&type=template&id=1c6c43ab"
import script from "./NewsInner.vue?vue&type=script&lang=js"
export * from "./NewsInner.vue?vue&type=script&lang=js"

import "./NewsInner.vue?vue&type=style&index=0&id=1c6c43ab&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__